import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import TodaysBreak from './TodaysBreak';
import TodayActivity from './TodayActivity';
import TodaysCallCard from './TodaysCallCard/TodaysCallCard';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActivityCardData } from './activityTrackerAction';
import { addClickstreamEvent } from 'src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from 'src/service/clickStream.constant';
import { RootState } from '@cp/src/store';

const ActivityTracker = ({ agentRefId }: { agentRefId?: string }) => {
  const dispatch = useDispatch();
  const trackerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const referenceId = useSelector((state: RootState) => state.common.userData.referenceId);

  const isAgentAdherenceEnabled = useSelector(
    (state: RootState) => state.common.featureFlags?.agentAdherenceEnabled
  );
  const agentReferenceId = useSelector((state: RootState) => state.common.userData.referenceId);

  const agentRefIdForActivityCard = agentRefId || agentReferenceId;
  useEffect(() => {
    if (agentRefIdForActivityCard) {
      dispatch(fetchActivityCardData(setIsLoading, agentRefIdForActivityCard));
    }
  }, [agentRefIdForActivityCard]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_ACTIVITY_TRACKER_PAGE_VIEW, {
            componentViewed: 'ActivityTracker'
          });
          observer.disconnect();
        }
      },
      {
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (trackerRef.current) {
      observer.observe(trackerRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className="flex flex-col gap-4 px-8" ref={trackerRef}>
      <Typography variant="h3" className="my-5">
        Today’s activity tracker
      </Typography>
      <div className="bg-white rounded-lg flex flex-row justify-between w-full gap-8">
        <div className="flex flex-col justify-between gap-2 w-1/2 h-full">
          <TodayActivity isLoading={isLoading} />
          <TodaysBreak isLoading={isLoading} />
        </div>
        <div className="w-1/2 mr-8">
          <TodaysCallCard agentRefId={agentRefIdForActivityCard} />
        </div>
      </div>
    </div>
  );
};

export default ActivityTracker;
